import { store } from "app.store";
import { formatString } from "./string-helper";

const currentCultureName = "CurrentCulture";
export const CoreResource = "Core";

export function momentDateTimeFormat() {
  const currentCultureName = getCurrentCulture();
  switch (currentCultureName) {
    case "en":
      return "MM/DD/YYYY hh:mm A";
    case "vi":
      return "DD/MM/YYYY hh:mm A";
    default:
      return "MM/DD/YYYY hh:mm A";
  }
}

export function momentDateFormat() {
  const currentCultureName = getCurrentCulture();
  switch (currentCultureName) {
    case "en":
      return "MM/DD/YYYY";
    case "vi":
      return "DD/MM/YYYY";
    default:
      return "MM/DD/YYYY";
  }
}

export function getCurrentCulture() {
  return localStorage.getItem(currentCultureName) ?? "vi";
}
export function setCurrentCulture(cultureName: string) {
  localStorage.setItem(currentCultureName, cultureName);
}

export function t(resourceName: string, ...params: string[]) {
  const resource = store.getState().localization.resource;
  if (params.length === 0) {
    return "";
  }
  const resourceKey = params[0].toString();
  params.splice(0, 1);
  return formatString(resource[resourceName][resourceKey] as string, ...params);
}
